import { CloseIcon } from "../../../Icons";
import { IconButton } from "../../Button";
import {
  StyledModalBody,
  StyledModalContainer,
  StyledModalHeader,
} from "../Modal-styled";

const ModalContainer = ({ title, children, handleClose }) => {
  return (
    <StyledModalContainer>
      <StyledModalHeader>
        <h1>{title}</h1>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </StyledModalHeader>
      <StyledModalBody>{children}</StyledModalBody>
    </StyledModalContainer>
  );
};

export default ModalContainer;
